var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.02 3.47991C17.08 1.53991 15.18 1.48991 13.19 3.47991L11.98 4.68991C11.88 4.78991 11.84 4.94991 11.88 5.08991C12.64 7.73991 14.76 9.85991 17.41 10.6199C17.45 10.6299 17.49 10.6399 17.53 10.6399C17.64 10.6399 17.74 10.5999 17.82 10.5199L19.02 9.30991C20.01 8.32991 20.49 7.37991 20.49 6.41991C20.5 5.42991 20.02 4.46991 19.02 3.47991Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.61 11.53C15.32 11.39 15.04 11.25 14.77 11.09C14.55 10.96 14.34 10.82 14.13 10.67C13.96 10.56 13.76 10.4 13.57 10.24C13.55 10.23 13.48 10.17 13.4 10.09C13.07 9.81005 12.7 9.45005 12.37 9.05005C12.34 9.03005 12.29 8.96005 12.22 8.87005C12.12 8.75005 11.95 8.55005 11.8 8.32005C11.68 8.17005 11.54 7.95005 11.41 7.73005C11.25 7.46005 11.11 7.19005 10.97 6.91005C10.9488 6.86465 10.9283 6.81949 10.9084 6.77458C10.7608 6.44127 10.3262 6.34382 10.0684 6.60158L4.33995 12.33C4.20995 12.46 4.08995 12.71 4.05995 12.88L3.51995 16.71C3.41995 17.39 3.60995 18.03 4.02995 18.46C4.38995 18.81 4.88995 19 5.42995 19C5.54995 19 5.66995 18.99 5.78995 18.97L9.62995 18.43C9.80995 18.4 10.06 18.28 10.18 18.15L15.9013 12.4287C16.1608 12.1692 16.0629 11.7237 15.7253 11.5797C15.6873 11.5634 15.6489 11.5469 15.61 11.53Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditV2);
export default __webpack_public_path__ + "static/media/edit-v2.201a42fe4a40e0d24b7ef3affed1e98d.svg";
export { ForwardRef as ReactComponent };